import useSession from 'hooks/useSession';
import useToast from 'hooks/useToast';
import { DeleteAccount, PDeleteAcountConfirm, PDeleteAcountWarn, UiModal } from 'libs/raas-ui-react-components/src/components';
import { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { deleteAxios } from 'services/api/api.service';
import { apiNames } from 'services/api/endpoint.service';
import { closeSession, IUserData, RaaSSession, SessionStorageItems } from 'services/user/user.session.service';
import { removeItemStorage } from 'services/util/sessionStorage.service';
import { DeleteAccountFlowLiterals, DeleteStatus } from './DeleteAccountFlow.model';
import { PDeleteConfirmLiterals, PDeleteWarnLiterals } from './DeleteAccountFlow.utils';

declare const window: any;
export const DeleteAccountFlow = () => {
  const [t/*, i18n*/] = useTranslation("deleteAccountFlow");
  const navigate = useNavigate();
  const { setSession, setLogged, setUserConnected } = useSession();
  const [step, setStep] = useState(0);
  const [showDeleteAccountModal, setShowModal] = useState(false);
  const [successCall, setSuccessCall] = useState(true);
  const [literalsModal, setliteralsModal] = useState({
    title: t("literals.title"),
    desc: t("literals.desc"),
    cancelbutton: t("literals.cancelbutton"),
    deletebutton: t("literals.deletebutton"),
    okbutton: t("literals.okbutton"),
  } as DeleteAccountFlowLiterals);
  const deleteWarnLiterals=PDeleteWarnLiterals(t);
  const deleteConfirmLiterals=PDeleteConfirmLiterals(t);
  const { openToast } = useToast();

  const handleBackStep = (step: number) => {
    setStep(step - 1);
  }

  const handleNextPage = (data: any) => {
    if (data.detail == "continue-delete-button") setStep(1)
    else if (data.detail == "confirm-delete-account-button") setShowModal(true)

  }

  const getStepPage = (s: number) => {
    switch (s) {
      case 0:
        return <PDeleteAcountWarn literals={deleteWarnLiterals} onNextPage={handleNextPage} />;
      case 1:
        return <PDeleteAcountConfirm literals={deleteConfirmLiterals} onNextPage={handleNextPage} onBackPage={() => handleBackStep(1)} />;
      default:
        <PDeleteAcountWarn />
    }
  }

  const handleDeleteAccount = () => {
    setShowModal(false);
    deleteAxios(apiNames.IDENTITY, true, "/customers/accounts")
      .then(() => {
        // TODO - SESSION CLOSE, REMAKE THE USE SESSION, WITH ALL THIS 3 LINES.
        setLogged(false);
        setSession({} as RaaSSession);
        setUserConnected({} as IUserData);
        removeItemStorage(SessionStorageItems.RAAS_USER);

        closeSession();
        navigate('/')
      })
      .catch((err => {
        manageErrors(err);
        setSuccessCall(false);
      }))

  }

  const manageErrors = (err: any) => {
    const status = err?.status;
    const code: string = err?.data?.errors?.[0]?.code;

    if (status && status === 409) {
      switch (code) {
        case "ERROR_APP_CUSTADMIN_IDENTITY_008": updateLiterals(DeleteStatus.activeBookings); break;
        case "ERROR_APP_CUSTADMIN_IDENTITY_012": updateLiterals(DeleteStatus.pendingPayment); break;
        case "ERROR_APP_CUSTADMIN_IDENTITY_013": updateLiterals(DeleteStatus.openedIssues); break;
      }
    }
  }

  const updateLiterals = (status: DeleteStatus) => {
    switch (status) {
      case DeleteStatus.pendingPayment:
        setliteralsModal({
          title: t("updateLiterals.pendingPayment.title"),
          desc: t("updateLiterals.pendingPayment.desc"),
          okbutton: t("updateLiterals.pendingPayment.okbutton"),
        })
        break;
      case DeleteStatus.activeBookings:
        setliteralsModal({
          title: t("updateLiterals.activeBookings.title"),
          desc: t("updateLiterals.activeBookings.desc"),
          okbutton: t("updateLiterals.activeBookings.okbutton"),
        })
        break;
      case DeleteStatus.openedIssues:
        setliteralsModal({
          title: t("updateLiterals.openedIssues.title"),
          desc: t("updateLiterals.openedIssues.desc"),
          okbutton: t("updateLiterals.openedIssues.okbutton"),
        })
        break;
      default:
        setliteralsModal({
          title: t("updateLiterals.default.title"),
          desc: t("updateLiterals.default.desc"),
          okbutton: t("updateLiterals.default.okbutton"),
        })
        break;
    }
    setShowModal(true);
  }

  const handleCloseModal = () => {
    setShowModal(false);
  }


  return (
    <>
      {getStepPage(step)}
      <UiModal open={showDeleteAccountModal} blockOverlay={true}>
        <DeleteAccount
          literals={literalsModal}
          successCall={successCall}
          onDeleteAccount={handleDeleteAccount}
          onCancelModal={handleCloseModal}
          onOkModal={handleCloseModal}
        />
      </UiModal>
    </>
  )
}
